<template>
    <component :is="$auth.isSubdomainActive() ? 'div' : 'common-page-plain'">
        <check-availability
            v-if="offer"
            :offer="offer"
            :moderatorNote="reservation?.moderatorNote"
            :categories="categories"
            :calendarEventId="$route.params.calendarEventId"
        ></check-availability>
    </component>
</template>

<script>
    import CheckAvailability from 'components/page-elements/availability/CheckAvailability'
    import OfferAPI from 'api/OfferAPI'
    import RoutesEnum from 'enums/routes.enum'
    import CalendarEventEnums from 'enums/calendar_event.enum'
    import CalendarEventAPI from 'api/CalendarEventAPI'

    export default {
        components: { CheckAvailability },

        data: () => ({
            offer: undefined,
            categories: undefined,
            reservation: undefined,
        }),

        methods: {
            loadOffer() {
                const isCalendarFiltered = 1
                return OfferAPI.getOfferById(this.$route.params.offerId, isCalendarFiltered)
                    .then((offer) => {
                        this.offer = offer
                        const categoryIds = this.$route.query.categoryIds
                        this.categories = this.offer.offerCategories.filter((item) => categoryIds.includes(item.id.toString()))
                        if (!this.categories) {
                            this.$toast.error(this.$t('validations.CATEGORY.CATEGORY_NOT_FOUND'))
                            if (this.$auth.isSubdomainActive()) {
                                this.$router.push({ name: RoutesEnum.SUBDOMAIN.COMPANY })
                            } else {
                                this.$router.push({ name: RoutesEnum.INDEX.HOME })
                            }
                        }
                    })
                    .catch((error) => {
                        if (error.error.message === 'OFFER.NOT_FOUND') {
                            this.$toast.error(this.$t(`validations.${error.error.message}`))
                        } else {
                            this.$toast.error(this.$t('common.errors.common_error'))
                        }
                        if (this.$auth.isSubdomainActive()) {
                            this.$router.push({ name: RoutesEnum.SUBDOMAIN.COMPANY })
                        } else {
                            this.$router.push({ name: RoutesEnum.INDEX.HOME })
                        }
                    })
            },

            getCalendarEvent() {
                this.$startLoader()
                return CalendarEventAPI.getById(this.$route.params.calendarEventId)
                    .then((res) => {
                        this.reservation = res
                    })
                    .catch((error) => {
                        if (
                            error.error.message === CalendarEventEnums.ERRORS.NOT_PERMISSIONED ||
                            error.error.message === CalendarEventEnums.ERRORS.NOT_FOUND
                        ) {
                            this.$toast.error(this.$t('common.errors.common_error'))
                            this.$router.push({ name: RoutesEnum.INDEX.HOME })
                        }
                    })
                    .finally(() => this.$stopLoader())
            },
        },

        mounted() {
            this.loadOffer()
            this.getCalendarEvent()
        },
    }
</script>
